import { useState } from 'react';

export interface SliderState {
  hoveredSection: 'left' | 'right' | null;
  expandedSection: 'left' | 'right' | null;
  previousExpandedSection: 'left' | 'right' | null;
  hasExpanded: boolean;
}

export interface SliderHandlers {
  onHover: (section: 'left' | 'right' | null) => void;
  onSectionClick: (section: 'left' | 'right') => void;
  onCenterButtonClick: () => void;
}

export const useSliderState = () => {
  const [hoveredSection, setHoveredSection] = useState<'left' | 'right' | null>(null);
  const [expandedSection, setExpandedSection] = useState<'left' | 'right' | null>(null);
  const [previousExpandedSection, setPreviousExpandedSection] = useState<'left' | 'right' | null>(null);
  const [hasExpanded, setHasExpanded] = useState(false);

  const handleSectionClick = (section: 'left' | 'right') => {
    if (!hasExpanded) {
      setPreviousExpandedSection(expandedSection);
      setExpandedSection(section);
      setHasExpanded(true);
    }
  };

  const handleCenterButtonClick = () => {
    if (!hasExpanded) {
      if (hoveredSection) {
        setPreviousExpandedSection(expandedSection);
        setExpandedSection(hoveredSection);
        setHasExpanded(true);
      }
    } else {
      setPreviousExpandedSection(expandedSection);
      if (expandedSection === 'left') {
        setExpandedSection('right');
      } else if (expandedSection === 'right') {
        setExpandedSection('left');
      } else {
        setExpandedSection(hoveredSection);
      }
    }
  };

  const handleHover = (section: 'left' | 'right' | null) => {
    setHoveredSection(section);
  };

  const state: SliderState = {
    hoveredSection,
    expandedSection,
    previousExpandedSection,
    hasExpanded,
  };

  const handlers: SliderHandlers = {
    onHover: handleHover,
    onSectionClick: handleSectionClick,
    onCenterButtonClick: handleCenterButtonClick,
  };

  return { state, handlers };
};
